import datos from "src/services/datos";

const impuestos_situaciones = new datos("impuestos_situaciones");
export const getImpuestosSituaciones = async () => {
  impuestos_situaciones.addCondition("impuestos_situaciones", "id", 0, ">");
  const response = await impuestos_situaciones.get();
  return response.wsResponse.impuestos_situaciones;
};
